const doc = [({"da":({"js":({"team_surveys":({"time_used":({"not_started":"Ikke startet", "one_week_or_more":"En uge+"})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;